import { render, staticRenderFns } from "./SimpleStatsWidget.vue?vue&type=template&id=9b834264&scoped=true"
import script from "./SimpleStatsWidget.vue?vue&type=script&lang=js"
export * from "./SimpleStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./SimpleStatsWidget.vue?vue&type=style&index=0&id=9b834264&prod&lang=scss&scoped=true"
import style1 from "./SimpleStatsWidget.vue?vue&type=style&index=1&id=9b834264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b834264",
  null
  
)

export default component.exports